import { composeIO } from 'react-compose-io'
import { titulosAbertosIO } from './TitulosAbertos.IO'
import { TitulosAbertosView } from './TitulosAbertos.View'

export const TitulosAbertos = composeIO(TitulosAbertosView, titulosAbertosIO)
